import { render } from "./DashboardSubscriptions.vue?vue&type=template&id=4e203466&scoped=true"
import script from "./DashboardSubscriptions.vue?vue&type=script&lang=js"
export * from "./DashboardSubscriptions.vue?vue&type=script&lang=js"

import "./DashboardSubscriptions.vue?vue&type=style&index=0&id=4e203466&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4e203466"]])

export default __exports__